import React, {useState} from 'react';

import {
  Box,
  HStack,
  Heading,
  Pressable,
  QuestionOutlineIcon,
  Text,
  VStack,
} from 'native-base';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../../../components/buttons';
import useToast from '../../../../../../../hooks';
import {IListOption} from '../../../../../../../context/user/Types';
import IDropDownOption from '../../../../../../../interfaces/ui/dropdown-option.interface';
import {
  DeleteIcon,
  AttachmentIcon,
} from '../../../../../../../components/icons';
import {Label} from '../../../../../../../components/labels';
import {IDocumentClient} from '../../../../../../../interfaces/dtos/salesman-client.interface';
import {IFileForm} from '../../../../../../../interfaces/forms';
import {message as t} from '../../../../../../../utils/messages';
import FileDropDown from '../../../../../../../components/inputs/file-dropdown';
import {isWebApp} from '../../../../../../../utils/platform/is-web';

interface FormProps {
  onHelpTap: () => void;
  onSubmit?: (data: IDocumentClient[]) => Promise<boolean>;
  onEndSubmit?: (success: boolean) => void;
  customerRequiredDocumentList: IListOption[];
}

type DocumentItem = {
  document: IDocumentClient;
  option: IListOption;
  fileName?: string;
};

export const DocumentsForm = ({
  onSubmit: launchSubmitEvent,
  onEndSubmit: launchEndSubmitEvent,
  onHelpTap: launcheHepTapEvent,
  customerRequiredDocumentList,
}: FormProps) => {
  const {showMessageError} = useToast();
  const [documentList, setDocumentList] = useState([] as DocumentItem[]);

  const handleClearForm = () => {
    setDocumentList([]);
  };

  const onSubmit = async () => {
    let success = false;
    if (isAllDocumentsUploaded()) {
      if (launchSubmitEvent) {
        success = await launchSubmitEvent(
          documentList.map(documentItem => documentItem.document),
        );
      }
      if (launchEndSubmitEvent) {
        launchEndSubmitEvent(success);
      }
    } else {
      showMessageError(t('salesman-documents-form-customer-add'));
    }
  };

  const parseIListOption = (list: IListOption[]): IDropDownOption[] => {
    return list.map(item => {
      return {
        label: item.title,
        value: item.value,
      };
    });
  };

  const handleQuestionDocuments = () => {
    if (launcheHepTapEvent) {
      launcheHepTapEvent();
    }
  };

  const isOdd = (n: number) => {
    return Math.abs(n % 2) === 1;
  };

  const getListOptions = () => {
    return customerRequiredDocumentList.filter(item => {
      if (documentList.find(document => document.option.value === item.value)) {
        return false;
      }
      return true;
    });
  };

  const getBgColor = (n: number) => {
    return isOdd(n) ? '#FFF' : '#0088FF10';
  };

  const handleFileDropDownChange = (selection: any, doc: IFileForm) => {
    if (selection && doc) {
      const documentType = customerRequiredDocumentList?.find(
        item => item.value === (selection as string),
      );
      if (documentType) {
        setDocumentList([
          ...documentList,
          {
            document: {
              documentType: documentType.value,
              document: doc,
            },
            option: documentType,
          },
        ]);
      }
    }
  };

  const handleRemoveButtonPress = (id: string) => {
    const documentListFiltered = documentList.filter(
      doc => doc.option.value !== id,
    );
    setDocumentList([...documentListFiltered]);
  };

  const isAllDocumentsUploaded = () => {
    return documentList.length === customerRequiredDocumentList.length;
  };

  return (
    <>
      <HStack
        width={'100%'}
        justifyContent={'space-between'}
        alignContent={'center'}
        alignItems={'center'}
        marginX={4}
        paddingRight={10}>
        {!isAllDocumentsUploaded() && (
          <>
            <FileDropDown
              label={'salesman-add-client-client-document-options'}
              options={parseIListOption(getListOptions())}
              onChange={handleFileDropDownChange}
            />
          </>
        )}
      </HStack>
      <HStack justifyContent={'space-between'} marginX={4}>
        <Label
          caption="salesman-add-customer-handle-documents-legend"
          color="#858597"
          fontWeight="medium"
        />
        <Pressable ml={3} mr={3} onPress={handleQuestionDocuments}>
          <QuestionOutlineIcon size={10} color="#0088FF" />
        </Pressable>
      </HStack>
      <VStack mt={2}>
        {documentList.map((document: DocumentItem, index: number) => (
          <HStack
            key={document.option.value}
            alignContent={'center'}
            alignItems={'center'}
            justifyContent={'space-between'}
            backgroundColor={getBgColor(index)}
            paddingX={4}
            mb={isWebApp ? 4 : 0}>
            <Box paddingBottom={2}>
              <AttachmentIcon width={22} color="#0088FF" />
            </Box>
            <VStack width={'72%'}>
              <Heading fontSize={16} color={'gray.600'} textAlign={'left'}>
                {document.option.title}
              </Heading>
              <Text color={'gray.500'}>{document.document.document.name}</Text>
            </VStack>
            <Pressable
              ml={3}
              mr={3}
              onPress={() => handleRemoveButtonPress(document.option.value)}>
              <DeleteIcon width={40} />
            </Pressable>
          </HStack>
        ))}
      </VStack>
      <Box mt={'5'} marginX={4}>
        <PrimaryButton label="sign-up-proof-send" onPress={() => onSubmit()} />
      </Box>
      <Box mt={5} marginX={4}>
        <SecondaryButton
          label="proof-button-cancel"
          onPress={handleClearForm}
        />
      </Box>
    </>
  );
};
